<template>
    <div class="min_box">
        <div class="top" v-if="hasData">
            当前总的网站<span class='num'>{{data[0].site_count}}</span>个，最近一次更新时间<span>{{data[0].create_time}}</span>
        </div>
        <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="false" rowKey="id" @change="handleChange"  >
            <span slot="action" slot-scope="text, record">
                <a @click="gotoStatistics(record)">{{text.site_use_count}}</a>
            </span>
        </a-table>

    </div>

</template>

<script>
    import API from "./api";
    import {changStatus, removeById,orderList} from "../../../utils/utils"
    
            // site_use_count
    const columns = [

        {
            title: "功能名称",
            key: "name",
            dataIndex: "name",
        },
        {
            title: "网站使用数",
            key: "action",
            scopedSlots: {customRender: "action"}
        },
        {
            title:"使用占比",
            key: "percentage",
            dataIndex: "percentage",
        }

    ];
    export default {
        name: 'index',
        data() {
            return {
                loading: true,
                data: [],
                columns,
                name:"",
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/DataStatistics/Important"; //设置左侧导航2-2 active
        },
        computed: {
            hasData() {
                return this.data.length > 0;
            },
        },
        methods: {
            handleChange(pagination, filters, sorter) {
            },
            getList(page) {
                API.service.GET_LIST().then(res => {
                    this.data = res.data.data
                    this.loading = false
                })
            },
            gotoStatistics(row){
                this.$router.push(`/DataStatistics/WebStatistics?id=${row.id}&name=${row.name}&type=important`)
            }
        },
        mounted() {
            this.getList()
        }

    }
</script>
<style scoped>
    .inputs {
        display: inline-block;
        width: 70px
    }
    .search-group {
        float: right;
    }
    .search-group .ant-input {
        width: 200px;
        margin: 0 8px 0 0 ;
    }
    .button-group {
        float: left;
    }
    #list_order {
        width: 50px;
    }
    .top .flex{ box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);padding:10px 16px;box-sizing: border-box;width: 60%;margin-bottom: 20px}
    .min_box{width: 60%}
    .top{margin-bottom: 20px;}
    .num{color: #1890ff;}
</style>
